import { Box, Typography } from "@mui/material";

const Footer = ({ sx, ...props }) => {
    return (
        <Box
            sx={{
                width: "100%",
                height: "60px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderTop: "1px solid rgba(0, 0, 0, 0.05)",
                backgroundColor: "transparent",
                ...sx
            }}
            {...props}
        >
            <Typography
                variant="body2"
                sx={{
                    color: "text.secondary",
                    fontSize: "0.85rem",
                    letterSpacing: "0.02em",
                    opacity: 0.8
                }}
            >
                © {new Date().getFullYear()} <strong>TVFM</strong>. All rights reserved.
            </Typography>
        </Box>
    );
};

export default Footer;
